import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getFilterIndicator, getSortIndicator } from '@/lib/tableHelpers'
import RozmowyTableRow from './RozmowyTableRow'

export default function RozmowyTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	hasDigRozmowyFilter,
	onOpenDigRozmowyFilter,
	hasDigNastepnejRozmowyFilter,
	onOpenDigNastepnejRozmowyFilter,
	hasSalesOpportunityFilter,
	onOpenSalesOpportunityFilter,
	hasPlacowkaFilter,
	onOpenPlacowkaFilter,
}) {
	const { t } = useTranslation()
	const rows = Array.isArray(data) ? data : []
	const columns = [
		{
			key: 'dig_rozmowy',
			label: t('conversations.list.table.conversationDate'),
			sortable: true,
			hasFilter: hasDigRozmowyFilter,
			onOpenFilter: onOpenDigRozmowyFilter,
		},
		{
			key: 'dig_nastepnej_rozmowy',
			label: t('conversations.list.table.nextConversation'),
			sortable: true,
			hasFilter: hasDigNastepnejRozmowyFilter,
			onOpenFilter: onOpenDigNastepnejRozmowyFilter,
		},
		{ key: 'imie_i_nazwisko', label: t('conversations.list.table.person'), sortable: true },
		{
			key: 'szansa',
			label: t('conversations.list.table.salesOpportunity'),
			sortable: false,
			hasFilter: hasSalesOpportunityFilter,
			onOpenFilter: onOpenSalesOpportunityFilter,
		},
		{
			key: 'id_placowka',
			label: t('conversations.list.table.facility'),
			sortable: false,
			hasFilter: hasPlacowkaFilter,
			onOpenFilter: onOpenPlacowkaFilter,
		},
		{ key: 'id_user', label: t('conversations.list.table.user'), sortable: false },
	]

	if (loading) return <LoadingIndicator />

	const renderColumnContent = column => {
		const columnLabel = column.sortable ? (
			<button
				type="button"
				className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
				onClick={() => onSort(column.key)}>
				{column.label}
				{getSortIndicator(column.key, sortColumn, sortDirection)}
			</button>
		) : (
			<span className="font-semibold text-gray-700">{column.label}</span>
		)

		if (!column.onOpenFilter) return columnLabel

		return (
			<div className="inline-flex items-center gap-1">
				{columnLabel}
				<button
					type="button"
					className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
					onClick={column.onOpenFilter}
					title={t('conversations.list.tooltips.filterColumn')}>
					{getFilterIndicator(column.hasFilter)}
				</button>
			</div>
		)
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						{columns.map(column => (
							<th key={column.key} className="py-2 px-4 border-b border-gray-300 text-left">
								{renderColumnContent(column)}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((item, index) => (
						<RozmowyTableRow
							key={item?._id || item?.id || index}
							rozmowa={item}
						/>
					))}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message={t('conversations.list.emptyState.title')}
						description={t('conversations.list.emptyState.description')}
					/>
				</div>
			) : null}
		</div>
	)
}
